import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import type { ClauseExtractionAgentBlockConfig } from '@mai/types';

import { createHandleId } from '../../utils/handle-ids';
import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type ClauseExtractionNodeType = Node<
  NodeData,
  'custom_clause_extraction_agent'
>;

export const ClauseExtractionNode: React.FC<
  NodeProps<ClauseExtractionNodeType>
> = ({ id, data, selected }) => {
  const config = data.config as ClauseExtractionAgentBlockConfig;
  const isConfigured = config.instructions;

  const subtitle = isConfigured ? 'Configured' : 'Not configured';

  // Extract connection state from node data for visual indicators
  const activeConnection = data.activeConnection;
  const isValidTargetHandle = data.isValidTargetHandle as
    | ((targetHandle: string) => boolean)
    | undefined;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="processing"
      subtitle={subtitle}
      selected={selected}
    >
      {/* Input handles - 3 separate ports */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id="file_id"
        blockId={id}
        style={{ top: '25%' }}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, 'file_id'))
            : undefined
        }
      />
      <NodeHandle
        type="target"
        position={Position.Left}
        id="dataset_id"
        blockId={id}
        style={{ top: '50%' }}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, 'dataset_id'))
            : undefined
        }
      />
      <NodeHandle
        type="target"
        position={Position.Left}
        id="context_dataset_id"
        blockId={id}
        style={{ top: '75%' }}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, 'context_dataset_id'))
            : undefined
        }
      />

      {/* Output handle */}
      <NodeHandle
        type="source"
        position={Position.Right}
        id="results"
        blockId={id}
        isActiveConnection={isActiveConnection}
      />
    </BaseNode>
  );
};
